import '../assets/NcGuestContent-j8ai4O1K.css';
import { defineComponent, onMounted, onUnmounted, createElementBlock, openBlock, renderSlot } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _hoisted_1 = { id: "guest-content-vue" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcGuestContent",
  setup(__props) {
    onMounted(() => {
      document.getElementById("content").classList.add("nc-guest-content");
    });
    onUnmounted(() => {
      document.getElementById("content").classList.remove("nc-guest-content");
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]);
    };
  }
});
const NcGuestContent = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-26ad2498"]]);
export {
  NcGuestContent as N
};
//# sourceMappingURL=NcGuestContent-CfCh49o0.mjs.map
